import { createSelector } from 'reselect';

export const getLayout = ({ layouts: { layouts } }, siteId) => layouts[siteId] || {};
export const getLayouts = (state) => state.layouts.layouts;
export const hasBeenUpdated = ({ layouts: { updatedLayouts } }, siteId) =>
  updatedLayouts.includes(siteId);
export const isImportedLayout = (state) => state.layouts.isImportingLayout;

export const getPagePanelTypeCounts = createSelector(
  [(state, siteId) => getLayout(state, siteId), (_state, _siteId, pageIndex) => pageIndex],
  (layout, pageIndex) => {
    const page = layout.pages?.[pageIndex];
    const panelTypeCounts = new Map();

    const addPanelType = (panel) => {
      if (!panel?.type) {
        return;
      }

      const panelTypeCount = panelTypeCounts.get(panel.type) ?? 0;
      panelTypeCounts.set(panel.type, panelTypeCount + 1);
    };

    page?.viewer?.panels?.forEach(addPanelType);
    page?.sections?.forEach((section) =>
      section.columns?.forEach((column) => column.panels?.forEach(addPanelType))
    );

    return panelTypeCounts;
  }
);
